import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { useQuery, useMutation } from "@apollo/react-hooks";
import { GET_APPOINTMENTS, ATTEND } from "../../queries/appointment.query";
import LoadingSpinner from "../../partials/loading";
import Pagination from "../../partials/pagination";
import YourAppointmentList from "./partials/Listing";
import { toast } from "react-toastify";
import { CleanMessage, AppName } from "../../util/app";
import { EventEmitter } from "../../event/EventEmitter";
import { EVENT_TARGET, ACTION_TYPE } from "../../event/model";
import { sendNotification } from "../../sockette";

function YourAppointment({ match, location }) {
    const [item, setItem] = useState(null);
    const [page, setPage] = useState(1);
    const [limit] = useState(25);

    const title = "Your Appointment";

    function scrollTop() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }

    const { loading, data, fetchMore, refetch } = useQuery(GET_APPOINTMENTS, {
        variables: { page, limit },
    });
    //  mutation
    const [updateAttend, { loading: aLoading }] = useMutation(ATTEND, {
        onCompleted: (data) => {
            const { message } = data.AttendAppointment;
            toast.success(message);
            sendNotification(message, ACTION_TYPE.UPDATE, EVENT_TARGET.APPOINTMENT);
        },
        onError: (e) => toast.error(CleanMessage(e.message)),
    });

    EventEmitter.subscribe(EVENT_TARGET.APPOINTMENT, () => refetch());

    return (
        <>
            <Helmet>
                <title>
                    {title} | {AppName}
                </title>
            </Helmet>

            <div className="row">
                {!item && (
                    <div className="col-md-12 fade-in">
                        <div className="card">
                            <div className="card-head">
                                <header>{title}</header>
                            </div>
                            <div className="card-body m-b-20" style={{ minHeight: "420px" }}>
                                <LoadingSpinner loading={loading || aLoading} />

                                <YourAppointmentList
                                    match={match}
                                    items={data && data.GetStaffAppointments.docs}
                                    onAttend={async ({ id }) => {
                                        await updateAttend({
                                            variables: { id },
                                        });
                                    }}
                                />
                            </div>
                            <div className="card-footer">
                                {data && (
                                    <Pagination
                                        {...data.GetStaffAppointments}
                                        length={data.GetStaffAppointments.docs.length}
                                        onPageClicked={async (page) => {
                                            setPage(page);
                                            await fetchMore({
                                                variables: { page },
                                                updateQuery: (prev, { fetchMoreResult }) => {
                                                    if (!fetchMoreResult) return prev;
                                                    return {
                                                        GetStaffAppointments: fetchMoreResult.GetStaffAppointments,
                                                    };
                                                },
                                            });
                                        }}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                )}
                {item && (
                    <div className="col-md-12 fade-in">
                        <div className="card">
                            <div className="card-head">
                                <header>
                                    <button
                                        onClick={() => {
                                            setItem(null);
                                            scrollTop();
                                        }}
                                        title="Back"
                                        className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored"
                                    >
                                        <i className="material-icons">keyboard_backspace</i>
                                    </button>
                                    Appointment Detail
                                </header>
                            </div>
                            <div className="card-body m-b-20"></div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}

export default YourAppointment;
